export default {
  setLoading (state, status) {
    state.loading = status
  },
  setQuotaInformation (state, quotaInformation) {
    state.quotaInformation = quotaInformation
  }
}
